// App.js
import React from 'react';
import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import WebSocketComponent from './components/WebSocketComponent';  // WebSocketComponent를 import
import Login from './components/Login';
import Main from './components/Main';
import ProtectedRoute from './components/ProtectedRoute';
import { checkAuth } from './auth';

function App() {
  const user = checkAuth();

  return (
    <BrowserRouter>
      <Routes>
        {/* root 페이지 */}
        <Route 
          path="/" 
          element={
            user ? (<Navigate to='/main' replace />) : (<Login />)
          } 
        />

        {/* 메인 페이지 */}
        <Route 
          path="/main" 
          element={
            user ? (
              <Main />
            ) : (
              <Navigate to="/" replace />
            )
          }
        />

        {/* 외부 도메인 접근 처리 - 와일드카드 사용 */}
        <Route 
          path="*" 
          element={
            user ? (
              <Main />
            ) : (
              <Navigate to="/" replace />
            )
          }
        />

        {/*<Route 
          path="/main" 
          element={
            checkAuth() ? (
              <Main />
            ) : (
              <Navigate to="/" replace />
            )
          } 
        />*/}
        
        {/*
        <Route 
          path="/aicc" 
          element={<WebSocketComponent />} 
        />
        
        <Route 
          path="/aica" 
          element={
            <ProtectedRoute>
              <Main />
            </ProtectedRoute>
          } 
        />
        */}

        {/* 다른 라우트들 */}
      </Routes>
    </BrowserRouter>
  );
}

export default App;

/*
function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<Login />} />
        <Route path="/AICC" element={<WebSocketComponent />} />
      </Routes>
    </Router>
  );
}
*/


